var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-pay-wrapper"},[_c('div',{staticClass:"btn-pay",class:{ disabled: !_vm.isAgree },on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" 立即报名 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }